module.exports = __webpack_public_path__ + "media/icons/tetimonial-icon-01-e737ed49.png";